// componentes
import React, { useContext, useEffect, useState, useLayoutEffect } from "react";
import Migas from "../migasGeomedellin/Migas";
import Search from "../buscador/Search";
import OpenModal from "../admin/OpenModal";
import { Container } from "react-bootstrap";
import PiePagina from "../piePagina/PiePagina";
import contextGeomedellin from "../../../context/contextGeomedellin";
import { UploadFileIcon } from "../../common/UploadFileIcon";
import { MdOutlineModeEdit } from "react-icons/md";

// custom hooks
import { usePermisions } from "../../../hooks/usePermisions";

// variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

export default function GeoServicios({
  idComponente,
  caractFiltro,
  descripcion,
  fraseCorta,
  imagen,
}) {
  //contexto global geomdellin, donde se almacenan los estados globales de la aplicación
  const { componentes, restablecerEstilos, refDivCard } =
    useContext(contextGeomedellin);

  const { permissions } = usePermisions(idComponente);

  const [rowPerPage, setRowPerPage] = useState(null);

  useLayoutEffect(() => {
    const numberCard = Math.floor(refDivCard.current.offsetWidth / 260) * 2;
    setRowPerPage(numberCard);

    window.scroll(0, 0);
    restablecerEstilos();
  }, []);

  return (
    <>
      <Container fluid={true} className="content-geoservicios">
        <div
          className="img-logo-goedervicios"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          {permissions.superAdmin ? (
            <div className="edit-banner">
              <UploadFileIcon
                icon={<MdOutlineModeEdit color="#fff" size={"20px"} />}
                idComponente={idComponente}
              />
            </div>
          ) : null}
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">Geoservicios</label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
          <label className="color-borde-img-banner"></label>
        </div>
        <Migas ruta="Geoservicios" />
        {permissions.admin || permissions.superAdmin ? (
          <div className="container-admin-btn">
            <OpenModal
              componentes={componentes}
              idComponente={idComponente}
              caractFiltro={caractFiltro}
              tituloAdmin={"Nuevo Geoservicio"}
            />
          </div>
        ) : (
          ""
        )}
        <Search
          position="vertical"
          caractFiltro={caractFiltro}
          element={idComponente}
          fraseCorta={fraseCorta}
          rowPerPage={rowPerPage}
        />
      </Container>
      <PiePagina fluid={true} />
    </>
  );
}
